import { useTranslations } from "../../lib/translations"
import { useStore } from "../../stores/store"
import { approvalsStore, pendingForAgent } from "../../stores/approvalsStore"
import { SignOffCard } from "../Approvals/SignOffCard"

export function TasksTab({ agent }) {
  const t = useTranslations()
  const approvals = useStore(approvalsStore, (s) => pendingForAgent(s, agent.id))

  if (approvals.length === 0) {
    return (
      <div className="cm-tabwrap">
        <div className="cm-coming-soon">{t("modal.tasks.empty")}</div>
      </div>
    )
  }

  return (
    <div className="cm-tabwrap">
      {approvals.map((a) => <SignOffCard key={a.id} approval={a} />)}
    </div>
  )
}
